// extracted by mini-css-extract-plugin
module.exports = {"hidden":"text_hidden__vwYAc","textEmphasis":"text_textEmphasis__pZYS5","ellipsis":"text_ellipsis__adkyU"};